type UploadFileOptions = {
  url: string;
  file: File;
};

const getCompleteUrl = (url: string): string =>
  url.match(/^\//) ? `${process.env.NEXT_PUBLIC_API_URL}${url}` : url;

const getFormDataBody = (attrs: Record<string, string | Blob>): FormData =>
  Object.keys(attrs).reduce((acc, key) => {
    acc.append(key, attrs[key]);
    return acc;
  }, new FormData());

export const uploadFile = async ({url, file}: UploadFileOptions): Promise<boolean> => {
  const uploadUrl = getCompleteUrl(url);
  const body = getFormDataBody({file});

  let res: Response | null;
  try {
    res = await fetch(uploadUrl, {
      method: 'POST',

      // Since the URL is a signed URL, this request should not have to set
      // the `Authorization` header.

      // We must NOT manually set the `Content-Type` header here because we
      // need `fetch` to automatically set it for us.

      // Since the `body` is a `FormData` instance, the `fetch` call will
      // recognize that and set the `Content-Type` header accordingly. We need
      // the `Content-Type` header to be set automatically by `fetch` so that
      // the `boundary=...` part of the header can be calculated and set at
      // the time of request.
      body,
    });
  } catch (err) {
    res = null;
    console.error('Error uploading file asset', err);
  }

  if (!res) {
    return false;
  }

  let result: Record<string, any> | null;
  try {
    result = await res.json();
  } catch (err) {
    result = null;
    console.error('Error parsing file upload result', err);
  }

  if (!result) {
    return false;
  }

  return !!result['success'];
};
